<template>
    <!-- gnbSrch_wrap -->
    <div :class="[topClass, {extend: screenMode == 'D'}]">
        <article class="srch_basic">
            <dl class="dl_search">
                <dd data-input-type="select">
                    <select class="slt_white w100p" v-model="searchKind" @change="changeSearchKind">
                        <option value="C">{{$t('FIELD.GLOBAL.MODEL.CODE')}}</option>
                        <option value="N">{{$t('FIELD.GLOBAL.MODEL.NAME')}}</option>
                        <option value="K">{{$t('FIELD.MYKNOWLEDGE.KEYWORD')}}</option>
                    </select>
                </dd>
                <dd class="srch_item_input clearable" data-input-type="input">
                    <input type="text" class="text_input w100p" ref="kword" v-model="keyword" @keyup="onAutoCmpl" @keyup.enter.stop="onSearch()"
                           @blur="inputBlur" @focus="inputFocus()" :maxLength="keywordMaxlength" :placeholder="$t('FIELD.GLOBAL.ETC.065')" v-clearable>
                    <i class="clearable_clear">X</i>
                </dd>
                <dd class="btn">
                    <a href="JavaScript:" @click="onSearch()" class="btn_srch" :class="{ disabled: isSearching }">
                        {{ isSearching ? 'Searching' : $t('BUTTON.GLOBAL.SEARCH') }}
                    </a>
                </dd>
            </dl>
        </article>
        <!-- Basic Search -->
        <article class="srch_more" v-if="screenMode == 'B' && searchMode != '0'"> <!-- 기본검색 -->
            <dl v-if="searchMode == '1' && recentModels && recentModels.length > 0" class="srch_history">
                <dt>{{$t('TITLE.SEARCH.RECENT.HISTORY')}}
                    <a href="JavaScript:" class="link_line delete" @click="rowDelete({})">{{$t('FIELD.SEARCH.CLEAR.ALL')}}</a>
                </dt>
                <dd> <!-- 최근검색어 -->
                    <ul>
                        <li v-for="model in recentModels" :key="model.ID" :class="{active: model.ID == keyword}">
                            <a href="JavaScript:" @click.stop="clickRecentModels(model)">{{model.LABEL}}</a>
                            <em><a href="JavaScript:" class="ico_gnb_delete" @click="rowDelete(model)"><span class="sr_only">delete</span></a></em>
                        </li>
                    </ul>
                </dd>
            </dl>
            <dl v-if="searchMode == '2' && autoCompletes && autoCompletes.length > 0" class="srch_autocomplete">
                <dd> <!-- 자동완성 -->
                    <ul class="scroll">
                        <li v-for="model in autoCompletes" :key="model.ID" :class="{active: model.ID == keyword}">
                            <a href="JavaScript:" @click="clickAutoCompl(model)">{{model.LABEL}}</a>
                        </li>
                    </ul>
                </dd>
            </dl>
        </article>
        <!-- //Basic Search -->
        <!-- Detail Search -->
        <article class="srch_detail" v-if="screenMode == 'D'"> <!-- 상세검색 -->
            <dl class="dl_select">
                <dt>{{$t('FIELD.GLOBAL.CATEGORY')}}</dt>
                <dd data-input-type="select">
                    <fieldset class="ui_fieldset set_3">
                        <label class="select-wrap">
                            <select class="slt_white w100p" id="prod1" v-model="prodCateCd1" @change="changeProdCd(1)">
                                <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                <option v-for="code in prodCategories1" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                            </select>
                        </label>
                        <label class="select-wrap">
                            <select class="slt_white w100p" id="prod2" v-model="prodCateCd2" @change="changeProdCd(2)">
                                <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                <option v-for="code in prodCategories2" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                            </select>
                        </label>
                        <label class="select-wrap">
                            <select class="slt_white w100p" id="prod3" v-model="prodCateCd3">
                                <option value='' selected>{{$t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY')}}</option>
                                <option v-for="code in prodCategories3" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                            </select>
                        </label>
                    </fieldset>
                </dd>
            </dl>
            <dl class="dl_input list_wrap"> <!-- Quick Category -->
                <dt>{{$t('FIELD.KNOWLEDGE.SEARCH.QUICKCATEGORY')}}</dt>
                <dd>
                    <ul class="ul_list">
                        <li v-for="cate in myCategories" :key="cate.category1 + cate.category2 + cate.category3">
                            <a href="JavaScript:" @click="quickCateSet(cate)">{{cate.categoryNm}}</a>
                        </li>
                    </ul>
                </dd>
            </dl>
            <dl class="dl_input"> <!-- 날짜 -->
                <dt>{{$t('BUTTON.FAST.DATE')}}</dt>
                <dd data-input-type="date">
                    <fieldset class="ui_fieldset">
                        <span class="date-wrap" style="display: inline-block;">
                            <label>
                                <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                            </label>
                            <div id="from-picker-container" style="margin-top: -1px;"></div>
                        </span>
                        <em class="txt_space"></em>
                        <span class="date-wrap" style="display: inline-block;">
                            <label>
                                <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                            </label>
                            <div id="to-picker-container" style="margin-top: -1px;"></div>
                        </span>
                    </fieldset>
                </dd>
            </dl>
        </article>
        <!-- //Detail Search -->
        <a v-if="bToggle" href="JavaScript:" class="btn_ico_srchBtm" @click="toggle()"><span class="sr_only">toggle</span></a>
    </div> <!-- gnbSrch_wrap -->
</template>

<script>
import Vue          from 'vue';
import qs           from 'query-string';
import axios        from 'axios';
import { SDLUtil }  from '@/utils';
import moment       from 'moment';
import DatePicker   from '~c/DatePicker';
import { EventBus } from '@/utils/EventBus';

require('moment-jdateformatparser');

const fetchKnowledgeSetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeSetup.skp`,
    qs.stringify({ WORK_TYPE : workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'searchArea',
    props: {
        'bToggle'   : { defult : false },
        'pKeyword'  : { defult : '' },
        'topClass'  : { defult : '' },
        'isSearching'    : { defult : false },
        'callSearchFunc' : { type: Function }
    },
	computed: {
		keywordMaxlength() {
            if (this.searchKind === 'C') {
                return 20;

            } else if (this.searchKind === 'N') {
                return 30;

            } else if (this.searchKind === 'K') {
                return 30;
            }
		},
	},
    data() {
        return {
            screenMode: 'B', // 'B':기본화면, 'D':상세화면
            searchMode: '1', // '1':recentModels, '2':autoCompletes, '3':detailSearch
            searchKind: 'C', // 'C':Code, 'N':Name, 'K':keyword
            isBlured: true,
            keyword: this.pKeyword, // 검색어
            autoCompletes: [],
            recentModels: [],
            cursorIndex: -1,
            FR_DATE: null,
            TO_DATE: null,
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd3: '',
            prodCateCd1Nm: '',
            prodCateCd2Nm: '',
            prodCateCd3Nm: '',
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],
            myCategories: [],
        };
    },
    methods: {
        async initRecentWords() {
//            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getRecentModels.skp`,
                    qs.stringify({}), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.recentModels = resp.data;
//                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.log('SearchArea.initRecentWords.Error ======> ', err);
                    SDLUtil.errorAlert(err);
//                    SDLUtil.showLoadingBar(false);
                });
        },
        // rowDelete
        async execServer(url, param) {
            return await axios
                .post(url,
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    console.log('save result ==> ', resp.data);
                    this.initRecentWords();
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        changeSearchKind() {
            if (this.searchKind == 'C') {
                this.onAutoCmpl({key: ''});
            } else {
                this.autoCompletes = [];
            }
            this.keyword = this.keyword.substr(0, this.keywordMaxlength);
        },
        async onAutoComplete() {
            const param = { keyword: this.keyword };
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getAutoComplete.skp`,
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.autoCompletes = resp.data;
                    this.$refs.kword.focus();
                })
                .catch(err => {
                    console.log('Err.onAutoComplete ======> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        onAutoCmpl(event) {
            if (event.key == 'Enter' || event.key == 'Escape') return;

            // 상하 화살표 키
            if (event.key == 'ArrowUp' || event.key == 'ArrowDown') { // 위 화살표
                if (event.key == 'ArrowUp') this.cursorIndex -= 1;
                if (event.key == 'ArrowDown') this.cursorIndex += 1;

                if (this.cursorIndex < 0) {
                    if (this.searchMode == '1') { // 최근검색어
                        this.cursorIndex = this.recentModels.length - 1;
                    } else if (this.searchMode == '2') { // 자동완성
                        this.cursorIndex = this.autoCompletes.length - 1;
                    }
                }

                if (this.searchMode == '1') { // 최근검색어
                    if (this.cursorIndex >= this.recentModels.length) this.cursorIndex = 0;
                    if (this.recentModels.length > 0) {
                        this.keyword = this.recentModels[this.cursorIndex].ID;
                        this.searchKind = this.recentModels[this.cursorIndex].SRCH_KIND;
                    }
                } else if (this.searchMode == '2') { // 자동완성
                    if (this.cursorIndex >= this.autoCompletes.length) this.cursorIndex = 0;
                    if (this.autoCompletes.length > 0) this.keyword = this.autoCompletes[this.cursorIndex].ID;
                }

                return;
            }

            if (this.searchKind == 'C') this.keyword = this.keyword.toUpperCase();

            if (this.screenMode == 'B') { // 기본검색 모드
                if (this.searchKind == 'C') { // 코드검색일 떄만 자동완성 작동
                    if (this.keyword.length > 2) { // 3자 이상이면...
                        this.searchMode = '2';
                        this.onAutoComplete();
                    } else if (this.keyword.length < 1){ // 2자 이하면 최근검색어 나오게..
                        this.searchMode = '1';
                    } else {
                        this.searchMode = '0';
                    }
                } else if (this.searchKind != 'C' && this.keyword.length == 0) { // 기본화면&코드검색이 아닐 때는 최근검색어만 나오게..
                    this.searchMode = '1';
                } else {
                    this.searchMode = '0';
                }
            }
        },
        inputBlur() {
            setTimeout(() => {
                if (this.isBlured) {
                    this.searchMode = '0';
                } else {
                    if (this.keyword.trim().length == 0) {
                        this.searchMode = '1';
                    } else if (this.keyword.trim().length > 2) {
                        this.searchMode = '2';
                    } else {
                        this.searchMode = '0';
                    }
                }
            }, 300);
            this.isBlured = true;
        },
        inputFocus() {
            if (this.keyword.length == 0)  {
                this.searchMode = '1';
            }
            this.isBlured = false;
        },
        clickRecentModels(model) {
            this.keyword = model.ID;
            this.searchKind = model.SRCH_KIND;
            this.searchMode = '0';
            this.isBlured = true;
        },
        clickAutoCompl(model) {
            this.keyword = model.ID;
            this.searchMode = '0';
            this.isBlured = true;
        },
        rowDelete(row) {
            let newList = [];
            this.recentModels.forEach(elm => {
                if (elm.ID != row.ID) newList.push(elm);
            });
            this.recentModels = newList;

            const url = `${SDLUtil.API_URL}/basis/search/deleteRecentModel.skp`;
            const param = { keyword : row.ID };
            this.execServer(url, param);
        },
        settingDetailScreen() {
            let FR_DT       = localStorage.getItem('search.FR_DT');
            let TO_DT       = localStorage.getItem('search.TO_DT');
            this.prodCateCd1  = localStorage.getItem('search.prodCateCd1') || '';
            this.prodCateCd2  = localStorage.getItem('search.prodCateCd2') || '';
            this.prodCateCd3  = localStorage.getItem('search.prodCateCd3') || '';

            this.$nextTick(() => {
                let frDate = (new moment()).add(-3, 'years').toDate();
                let toDate = (new moment()).toDate();
                if (FR_DT && TO_DT) {
                    frDate = new Date(FR_DT);
                    toDate = new Date(TO_DT);
                }

                let delay = (this.topClass == 'gnbSrch_wrap') ? 100 : 500;
                setTimeout(() => {
                    this.rangePicker = DatePicker.createRangeWithOpener(
                        'from-picker-container', 'fromDate', 'icoFromDate',
                        'to-picker-container', 'toDate', 'icoToDate',
                        { type: 'date', locale: 'en', showToday: false },
                        frDate, toDate
                    );
                }, delay);

                let param = {codeCategoryId : 'PRODUCT_GROUP'};
                this.loadProducts(1, param, this.prodCateCd1, this.prodCateCd2, this.prodCateCd3);
            });
        },
        // 기본/상세화면 toggle
        toggle() {
            this.screenMode = (this.screenMode == 'B') ? 'D' : 'B';

            if (this.screenMode == 'D') {
                this.settingDetailScreen();
            }

            this.$refs.kword.focus();
        },
        loadProducts(depth, param, defVal1, defVal2, defVal3) {
            param.depth     = depth;
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/system/userRole/productCategories.skp`,
                qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                },
            ).then(resp => {
                if (depth == 1) { // product 1depth
                    this.prodCategories1 = resp.data;
                    this.prodCateCd1       = defVal1;
                    if (defVal1) {
                        param.parentCode     = defVal1;
                        this.loadProducts(2, param, defVal1, defVal2, defVal3);
                    }
                } else if (depth == 2) { // product 2depth
                    this.prodCategories2 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCateCd2   = '';
                        this.prodCateCd3   = '';
                    } else {
                        if (defVal2) {
                            this.prodCateCd2 = defVal2;
                            param.parentCode = defVal2;
                            this.loadProducts(3, param, defVal1, defVal2, defVal3);
                        } else {
                            this.prodCateCd2 = '';
                            this.prodCateCd3 = '';
                            this.prodCategories3 = [];
//                            param.parentCode = resp.data[0].code;
//                            this.loadProducts(3, param, defVal1, defVal2);
                        }
                    }
                } else if (depth == 3) { // product 3depth
                    this.prodCategories3 = resp.data;
                    if (defVal3) this.prodCateCd3 = defVal3;
                    else         this.prodCateCd3 = '';
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        changeProdCd(depth) {
            if (depth == 1) { // product code - 1Depth
                if (!this.prodCateCd1) {
                    this.prodCategories2 = [];
                    this.prodCateCd2 = '';
                    this.prodCategories3 = [];
                    this.prodCateCd3 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCateCd1};
                    this.loadProducts(2, param, this.prodCateCd1);
                }
            } else if (depth == 2) { // product code - 2Depth
                if (!this.prodCateCd2) {
                    this.prodCategories3 = [];
                    this.prodCateCd3 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCateCd2};
                    this.loadProducts(3, param, this.prodCateCd1, this.prodCateCd2);
                }
            }
        },
        // SNB 태그 생성
        setLinkedName(name1, name2, name3) {
            let linkedName = [], gt = " > ";
            if(!SDLUtil.isNull(name1)) { linkedName.push(name1); }
            if(!SDLUtil.isNull(name2)) { linkedName.push(gt); linkedName.push(name2); }
            if(!SDLUtil.isNull(name3)) { linkedName.push(gt); linkedName.push(name3); }
            return linkedName.join("");
        },
        // Quick Category List 설정
        setQuickCategoryList(res) {
            // Quick Category data setting
            let refineCategoryList = [], quickCategoryList = [];
            if (SDLUtil.isNull(res.quickCategory.result)) {
                quickCategoryList = res.quickCategory.rowData;
            } else {
                quickCategoryList = res.quickCategory.result.rowData;
            }
            if (quickCategoryList.length > 0) {
                quickCategoryList = _.sortBy(quickCategoryList, ["ROW_NUM"]);
                quickCategoryList.forEach(category => {
                    if (!SDLUtil.existArrays(refineCategoryList, 'category3', category.WORK_KEY_3)) { // 중복된거 걸러내기
                        refineCategoryList.push({
                            categoryNm: this.setLinkedName(category.WORK_KEY_1_NM, category.WORK_KEY_2_NM, category.WORK_KEY_3_NM),
                            category1: category.WORK_KEY_1 || '',
                            category2: category.WORK_KEY_2 || '',
                            category3: category.WORK_KEY_3 || '',
                        });
                    }
                });
                this.myCategories = refineCategoryList;
            }
        },
        // Quick Category 데이터 로딩
        loadMyQuickCategory() {
            fetchKnowledgeSetting('CATEGORY')
                .then(res => { this.setQuickCategoryList({ quickCategory: res.data }); })
                .catch(err => { SDLUtil.errorAlert(err); });
        },
        // Quick Category 클릭 시...
        quickCateSet(cate) {
            this.keyword = '';
            this.prodCateCd1 = cate.category1;
            let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCateCd1};
            this.loadProducts(2, param, cate.category1, cate.category2, cate.category3);
        },
        onSearch() {
            if (this.isSearching) {
              SDLUtil.alert({
                title: 'Search Prompt',
                msg: 'Data querying in progress, please do not repeat the query',
              });
              return;
            };
            this.$emit('search-toggle');
            let FRDT = '', TODT = '', advProduct = '';
            if (this.screenMode == 'D') {
                if (this.prodCateCd1) advProduct  = 'first^' + $('#prod1 option:selected').text();
                if (this.prodCateCd2) advProduct += ':second^' + $('#prod2 option:selected').text();
                if (this.prodCateCd3) advProduct += ':third^' + $('#prod3 option:selected').text();
                advProduct = advProduct.replace('&', '##');
                const mFormat = localStorage.getItem('mDateFormat');
//                FRDT = moment(this.FR_DATE.getDate(), mFormat).format(mFormat).toString();
//                TODT = moment(this.TO_DATE.getDate(), mFormat).format(mFormat).toString();
                FRDT = this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '';
                TODT = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '';
            }
            let param = {
                  searchKind : this.searchKind
                , screenMode : this.screenMode
                , keyword    : this.keyword
                , prodCateCd1  : this.prodCateCd1
                , prodCateCd2  : this.prodCateCd2
                , prodCateCd3  : this.prodCateCd3
                , advProduct : advProduct
                , FR_DT      : FRDT
                , TO_DT      : TODT
            };
            this.searchMode = '0';
            this.callSearchFunc(param);
        },
        resetKeyword(param) {
            this.keyword = param.keyword;
            if (param.searchKind) this.searchKind = param.searchKind;
        },
    },
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
        keyword() {
            if (!this.keyword || this.keyword.trim() == '') {
                this.cursorIndex = -1;
                this.onAutoCmpl({key:''});
                this.$refs.kword.focus();
            } else {

            }
        }
    },
    mounted() {
        this.keyword    = localStorage.getItem('search.keyword') || '';
        this.screenMode = localStorage.getItem('search.screenMode') || 'B';
        this.searchKind = localStorage.getItem('search.searchKind') || 'C';

        this.initRecentWords();
//        this.loadProducts(1, { depth : 1 }, ); // 상세검색에서 사용
        this.loadMyQuickCategory(); // 상세검색에서 Quick Category
//        this.$refs.kword.focus();
        this.searchMode = '0';

        if (this.screenMode == 'D') {
            this.settingDetailScreen();
        }
    },
    activated() {
        // 이벤트 등록
        EventBus.$on('recent-words-reload', () => { this.initRecentWords(); });
        EventBus.$on('search-reset-keyword', param => { this.resetKeyword(param); });
    },
    // keep-alive deactivated
    deactivated() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('recent-words-reload');
        EventBus.$off('search-reset-keyword');
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchArea.vue